import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=6a26f3fa&"
import script from "./Faq.vue?vue&type=script&lang=ts&"
export * from "./Faq.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports